import {CheckCircleOutlineTwoTone} from '@mui/icons-material';
import {ROUTES} from '../../utils/ROUTES';
import {useNavigate} from 'react-router-dom';
import {Button} from 'antd';

export default function SummarySection({h3, p}) {
	const navigate = useNavigate();
	return (
		<div className="py-20 px-2 bg-backgroundGreyBlue">
			<div className="w-full max-w-[1050px] p-6 flex flex-col items-center gap-6 rounded-lg mx-auto bg-deepBlue">
				<h3 className="text-white text-2xl font-light">{h3}</h3>
				<div className="flex gap-6 flex-wrap justify-center items-start  max-w-full">
					<img src="/images/summary-section/role-insight.png" alt="Role Insight" className="rounded-lg max-w-full object-contain h-full" width={450} height={500} />
					<div className="w-[450px] max-w-full text-white px-2 pt-3">
						{p.map((sentence: string, index: number) => (
							<p key={index} className={`mb-2 text-white text-sm font-light flex items-top gap-2`}>
								<CheckCircleOutlineTwoTone className="mt-1 text-white text-base" />
								{sentence}
							</p>
						))}
					</div>
				</div>

				<Button
					type="primary"
					className="h-[40px] w-full max-w-[300px] bg-backgroundGreyBlue/20 hover:bg-backgroundGreyBlue/10 border-white/10 border-1 mt-3"
					onClick={() => navigate(ROUTES.POST_JOB)}>
					Get Started
				</Button>
			</div>
		</div>
	);
}
